export enum ChallengClaimTestIds {
  READ_ONLY = 'challenge_readonly_section',
  CLAIMING_SECTION = 'challenge_claiming_section',
  PROGRESS_SECTION = 'challenge_progress_section'
}
